var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CardList',{attrs:{"list":_vm.list,"type":"other","isShowLoading":_vm.isShowLoading,"owerfrom":"gallery"}}),(!_vm.ending && !_vm.isShowLoading)?_c('div',{staticClass:"loadmore",on:{"click":_vm.loadList}},[_c('div',{staticClass:"Text"},[_vm._v(_vm._s(_vm.$t("loadMore")))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }